import React from 'react';
import { replaceAllComplex, replaceAll } from '../../../../../mol_function';
import { getKalenderSubtitel } from '../overrides';

import './SubTitle.css';

interface SubTitleProp {
  attribute: any[];
  category: string;
  domainPrefix: string;
}

export default class SubTitle extends React.Component<SubTitleProp> {
  getProp(propName: string) {
    for (let i = 0; i < this.props.attribute.length; i++) {
      if (this.props.attribute[i].name == propName)
        return this.props.attribute[i];
    }
    return null;
  }

  render() {
    let getProp = (propName: string) => {
      for (let i = 0; i < this.props.attribute.length; i++) {
        if (this.props.attribute[i].name == propName)
          return this.props.attribute[i];
      }
      return null;
    };

    switch (this.props.category) {
      case 'Buch': {
        let htmlSprache = null;
        let attributeSprache = getProp('Sprache');
        if (
          attributeSprache != null &&
          attributeSprache.value != null &&
          attributeSprache.value != 'Deutsch' &&
          attributeSprache.value != 'ger'
        ) {
          let spracheArray = [];

          if (Array.isArray(attributeSprache.value)) {
            spracheArray = attributeSprache.value;
          } else spracheArray.push(attributeSprache.value);

          htmlSprache = (
            <React.Fragment>
              {' (' +
                spracheArray.map((sitem, sindex) => {
                  return replaceAll(sitem, '|', ', ');
                }) +
                ')'}
              <br />
            </React.Fragment>
          );
        }

        let htmlTitelzusatz = null;
        let attributeTitelzusatz = getProp('Titelzusatz');
        if (
          attributeTitelzusatz != null &&
          attributeTitelzusatz.value != null
        ) {
          htmlTitelzusatz = (
            <React.Fragment>
              {replaceAllComplex(attributeTitelzusatz.value, [
                { s: '\\"', r: '"' },
                { s: "\\'", r: "'" },
              ])}
              <br />
            </React.Fragment>
          );
        }

        let htmlAutor = null;
        let attributeAutor = getProp('Autor');
        if (attributeAutor != null && attributeAutor.value != null) {
          let autorsArray = [];
          if (Array.isArray(attributeAutor.value)) {
            autorsArray = attributeAutor.value;
          } else {
            autorsArray.push(attributeAutor.value);
          }
          htmlAutor = (
            <React.Fragment>
              {autorsArray
                .map((item, index) => {
                  return (
                    <a
                      key={'productAuth' + index}
                      href={
                        this.props.domainPrefix +
                        '/Autor/' +
                        encodeURI(item) +
                        '/s/'
                      }
                      title={'mehr von ' + item}
                    >
                      {item}
                    </a>
                  );
                })
                .reduce((prev, curr) => {
                  return (
                    <React.Fragment>
                      {prev}
                      {curr != null ? <span className="black"> & </span> : null}
                      {curr}
                    </React.Fragment>
                  );
                })}
            </React.Fragment>
          );
        }
        return (
          <React.Fragment>
            <span className="titel">{this.getTittleHtml()}</span>
            <span className="titel_sub">
              {htmlSprache}
              {htmlTitelzusatz}
            </span>
            <span className="titel_autor">{htmlAutor}</span>
          </React.Fragment>
        );
      }

      case 'Musik': {
        let htmlMedium = null;
        let attributeMedium = getProp('Medium');
        if (attributeMedium != null && attributeMedium.value != null) {
          htmlMedium = (
            <span className="titel_head">
              <a
                href={
                  this.props.domainPrefix +
                  '/Medium/' +
                  replaceAllComplex(attributeMedium.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={'stöbern Sie in ' + attributeMedium.value + '.'}
              >
                {attributeMedium.value}
              </a>

              <br />
            </span>
          );
        }

        let htmlTitelzusatz = null;
        let attributeTitelzusatz = getProp('Titelzusatz');
        if (
          attributeTitelzusatz != null &&
          attributeTitelzusatz.value != null
        ) {
          htmlTitelzusatz = (
            <React.Fragment>
              {replaceAllComplex(attributeTitelzusatz.value, [
                { s: "\\'", r: "'" },
              ]) + ' '}
              <br />
            </React.Fragment>
          );
        }

        let htmlInterpret = null;
        let attributeInterpret = getProp('Interpret');
        if (attributeInterpret != null && attributeInterpret.value != null) {
          htmlInterpret = (
            <React.Fragment>
              von{' '}
              <a
                href={
                  this.props.domainPrefix +
                  '/Interpret/' +
                  replaceAllComplex(attributeInterpret.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={
                  'mehr von ' +
                  replaceAllComplex(attributeInterpret.value, [
                    { s: "\\'", r: "'" },
                  ])
                }
              >
                {replaceAllComplex(attributeInterpret.value, [
                  { s: "\\'", r: "'" },
                ])}
              </a>
            </React.Fragment>
          );
        }

        return (
          <React.Fragment>
            {htmlMedium}
            {this.getTittleHtml()}
            <span className="titel_sub">{htmlTitelzusatz}</span>
            <span className="titel_autor">{htmlInterpret}</span>
          </React.Fragment>
        );
      }
      case 'Spielware': {
        let htmlHersteller = null;
        let attributeHersteller = getProp('Hersteller');
        if (attributeHersteller != null && attributeHersteller.value != null) {
          htmlHersteller = (
            <span className="titel_head">
              <a
                href={
                  this.props.domainPrefix +
                  '/Hersteller/' +
                  replaceAllComplex(attributeHersteller.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={'mehr von ' + attributeHersteller.value + '.'}
              >
                {attributeHersteller.value}
              </a>
              <br />
            </span>
          );
        }
        let htmltitelzusatz = this.getTitelzusatzHtml();
        if (htmltitelzusatz != null)
          htmltitelzusatz = (
            <React.Fragment>
              {htmltitelzusatz}
              <br />
            </React.Fragment>
          );

        let htmlPuzzleteile = null;
        let attributePuzzleteile = getProp('Puzzleteile');
        if (
          attributePuzzleteile != null &&
          attributePuzzleteile.value != null
        ) {
          htmlPuzzleteile = (
            <span className="titel_head">
              <a
                href={
                  this.props.domainPrefix +
                  '/Puzzleteile/' +
                  replaceAllComplex(attributePuzzleteile.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={
                  'weitere Puzzles mit ' +
                  attributePuzzleteile.value +
                  ' Teilen'
                }
              >
                {attributePuzzleteile.value} Puzzleteile
              </a>
              <br />
            </span>
          );
        }

        let htmlTeile = null;
        let attributeTeile = getProp('Teile');
        if (attributeTeile != null && attributeTeile.value != null) {
          htmlTeile = (
            <span className="titel_head">
              <a
                href={
                  this.props.domainPrefix +
                  '/Teile/' +
                  replaceAllComplex(attributeTeile.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={'mehr Spielzeug mit' + attributeTeile.value + ' Teilen'}
              >
                enthält {attributeTeile.value} Teile
              </a>
              <br />
            </span>
          );
        }

        return (
          <React.Fragment>
            {htmlHersteller}
            {this.getTittleHtml()}
            {htmltitelzusatz}
            {htmlPuzzleteile}
            {htmlTeile}
          </React.Fragment>
        );
      }

      case 'Schreibwaren': {
        let htmlHersteller = this.getHerstellerHtml();
        let titelzusatzHtml = this.getTitelzusatzHtml();
        if (titelzusatzHtml != null)
          titelzusatzHtml = (
            <React.Fragment>
              {titelzusatzHtml}
              <br />
            </React.Fragment>
          );
        return (
          <React.Fragment>
            <span className="titel_head">{htmlHersteller}</span>
            <span className="titel">{this.getTittleHtml()}</span>
            <span className="titel_sub">{titelzusatzHtml}</span>
          </React.Fragment>
        );
      }

      case 'Lifestyle': {
        let htmlHersteller = this.getHerstellerHtml();

        let htmlFormat = null;
        let attributeFormat = getProp('Format');
        if (attributeFormat != null && attributeFormat.value != null) {
          htmlFormat = (
            <React.Fragment>
              <a
                href={
                  this.props.domainPrefix +
                  '/Format/' +
                  replaceAllComplex(attributeFormat.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={attributeFormat.value}
              >
                {attributeFormat.value}
              </a>
              <br />
            </React.Fragment>
          );
        }
        return (
          <React.Fragment>
            <span className="titel_head">
              {htmlHersteller}
              {htmlFormat}
            </span>
            {this.getTittleHtml()}
            <span className="titel_sub">{this.getTitelzusatzHtml()}</span>
          </React.Fragment>
        );
      }

      case 'Kalender': {
        return getKalenderSubtitel(
          getProp,
          () => this.getTittleHtml(),
          () => this.getTitelzusatzHtml(),
        );
      }

      case 'Software': {
        let htmlMedium = null;
        let attributeMedium = getProp('Medium');
        if (attributeMedium != null && attributeMedium.value != null) {
          htmlMedium = (
            <span className="titel_head">
              <a
                href={
                  this.props.domainPrefix +
                  '/Medium/' +
                  replaceAllComplex(attributeMedium.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={'stöbern Sie in ' + attributeMedium.value + '.'}
              >
                {attributeMedium.value}
              </a>

              <br />
            </span>
          );
        }

        return (
          <React.Fragment>
            {htmlMedium}
            {this.getTittleHtml()}
          </React.Fragment>
        );
      }

      case 'Game': {
        let htmlSystem = null;
        let attributeSystem = getProp('System');
        if (attributeSystem != null && attributeSystem.value != null) {
          htmlSystem = (
            <span className="titel_head">
              <a
                href={
                  this.props.domainPrefix +
                  '/System/' +
                  replaceAllComplex(attributeSystem.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={'stöbern Sie in ' + attributeSystem.value + '.'}
              >
                {attributeSystem.value}
              </a>

              <br />
            </span>
          );
        }

        return (
          <React.Fragment>
            <span className="titel_head">
              {htmlSystem}
              <span className="titel">{this.getTittleHtml()}</span>
              <span className="titel_sub">
                <br />
                {this.getTitelzusatzHtml()}
              </span>
            </span>
          </React.Fragment>
        );
      }

      case 'Film': {
        let htmlMedium = null;
        let attributeMedium = getProp('Medium');
        if (attributeMedium != null && attributeMedium.value != null) {
          htmlMedium = (
            <span className="titel_head">
              <a
                href={
                  this.props.domainPrefix +
                  '/Medium/' +
                  replaceAllComplex(attributeMedium.value, [
                    { s: '/', r: '___' },
                    { s: '&', r: '_-_' },
                    { s: '?', r: '%3F' },
                    { s: '!', r: '0_0' },
                  ]) +
                  '/s/'
                }
                title={'stöbern Sie in ' + attributeMedium.value + '.'}
              >
                {attributeMedium.value}
              </a>

              <br />
            </span>
          );
        }

        let htmlStaffel = null;
        let attributeStaffel_von = getProp('Staffel_von');
        let attributeStaffel_bis = getProp('Staffel_bis');
        if (
          attributeStaffel_von != null &&
          attributeStaffel_von.value != null
        ) {
          let htmlStafelBis = null;
          if (
            attributeStaffel_bis != null &&
            attributeStaffel_bis.value != null
          ) {
            htmlStafelBis = (
              <React.Fragment>- {attributeStaffel_bis.value}</React.Fragment>
            );
          }
          htmlStaffel = (
            <React.Fragment>
              Staffel {attributeStaffel_von.value} {htmlStafelBis}
            </React.Fragment>
          );
        }

        let htmlSchauspieler = null;
        let attributeSchauspieler = getProp('Schauspieler');
        if (
          attributeSchauspieler != null &&
          attributeSchauspieler.value != null
        ) {
          let schauspielerArray = [];

          if (Array.isArray(attributeSchauspieler.value)) {
            schauspielerArray = attributeSchauspieler.value;
          } else {
            schauspielerArray.push(attributeSchauspieler.value);
          }

          htmlSchauspieler = (
            <React.Fragment>
              {schauspielerArray
                .map((item, index) => {
                  if (index < 4)
                    return (
                      <a
                        key={'productAuth' + index}
                        href={
                          this.props.domainPrefix +
                          '/Schauspieler/' +
                          replaceAllComplex(item, [
                            { s: '/', r: '___' },
                            { s: '&', r: '_-_' },
                            { s: '?', r: '%3F' },
                            { s: '!', r: '0_0' },
                          ]) +
                          '/s/'
                        }
                        title={'mehr von ' + item}
                      >
                        {item}
                      </a>
                    );
                  else return null;
                })
                .reduce((prev, curr) => {
                  return (
                    <React.Fragment>
                      {prev}
                      {curr != null ? <span className="black"> & </span> : null}
                      {curr}
                    </React.Fragment>
                  );
                })}
            </React.Fragment>
          );
        }

        return (
          <React.Fragment>
            <span className="titel_head">
              {htmlMedium}
              <span className="titel">{this.getTittleHtml()}</span>
              <span className="titel_sub">{this.getTitelzusatzHtml()}</span>
              <span className="titel_autor">{htmlSchauspieler}</span>
            </span>
          </React.Fragment>
        );
      }

      default:
        return <div>{this.getTittleHtml()}</div>;
    }
  }
  getTittleHtml() {
    let htmlTitel = null;
    let attributeTitel = this.getProp('Titel');
    if (attributeTitel != null && attributeTitel.value != null) {
      htmlTitel = (
        <React.Fragment>
          {replaceAllComplex(attributeTitel.value, [
            { s: '\\"', r: '"' },
            { s: "\\'", r: "'" },
          ])}
          <br />
        </React.Fragment>
      );
    }
    return htmlTitel;
  }

  getTitelzusatzHtml() {
    let htmlTitelzusatz = null;
    let attributeTitelzusatz = this.getProp('Titelzusatz');
    if (attributeTitelzusatz != null && attributeTitelzusatz.value != null) {
      htmlTitelzusatz = (
        <React.Fragment>
          {replaceAllComplex(attributeTitelzusatz.value, [
            { s: '\\"', r: '"' },
          ])}
          <br />
        </React.Fragment>
      );
    }
    return htmlTitelzusatz;
  }
  getHerstellerHtml() {
    let htmlHersteller = null;
    let attributeHersteller = this.getProp('Hersteller');
    if (attributeHersteller != null && attributeHersteller.value != null) {
      htmlHersteller = (
        <span className="titel_head">
          <a
            href={
              this.props.domainPrefix +
              '/Hersteller/' +
              replaceAllComplex(attributeHersteller.value, [
                { s: '/', r: '___' },
                { s: '&', r: '_-_' },
                { s: '?', r: '%3F' },
                { s: '!', r: '0_0' },
              ]) +
              '/s/'
            }
            title={'mehr von ' + attributeHersteller.value + '.'}
          >
            {attributeHersteller.value}
          </a>
          <br />
        </span>
      );
    }
    return htmlHersteller;
  }
}
